import { ChangeDetectionStrategy, Component } from '@angular/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';

@Component({
  selector: 'app-info-modal',
  imports: [],
  templateUrl: './info-modal.html',
  styleUrl: './info-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoModal {
  protected readonly context = injectContext<TuiDialogContext<string, string>>();
}
